/***
 * 新老客留存率分析
 */
import { post, get, postJson, put, postBlob } from '../axios'

//导出数据
export const exportDataOne = p => get(`/customer-analysis/retentionAnalysis/export`, p);

// 列表数据
export const getTableData = p => get(`/customer-analysis/retentionAnalysis/list`, p);